var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAppointmentIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.1 6.9H36.8V2.3C36.8 1.69 36.5577 1.10499 36.1263 0.673654C35.695 0.242321 35.11 0 34.5 0C33.89 0 33.305 0.242321 32.8736 0.673654C32.4423 1.10499 32.2 1.69 32.2 2.3V6.9H13.8V2.3C13.8 1.69 13.5577 1.10499 13.1263 0.673654C12.695 0.242321 12.11 0 11.5 0C10.89 0 10.305 0.242321 9.87365 0.673654C9.44232 1.10499 9.2 1.69 9.2 2.3V6.9H6.9C5.07001 6.9 3.31496 7.62696 2.02096 8.92096C0.726962 10.215 0 11.97 0 13.8V16.1H46V13.8C46 11.97 45.273 10.215 43.979 8.92096C42.685 7.62696 40.93 6.9 39.1 6.9ZM0 39.1C0 40.93 0.726962 42.685 2.02096 43.979C3.31496 45.273 5.07001 46 6.9 46H39.1C40.93 46 42.685 45.273 43.979 43.979C45.273 42.685 46 40.93 46 39.1V20.7H0V39.1Z",
    fill: "#6045EB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppointmentIcon);
export default __webpack_public_path__ + "static/media/appointment-icon.2f707d48ef0ec4838620df05f1f7b085.svg";
export { ForwardRef as ReactComponent };